import {Controller} from "@hotwired/stimulus"
import React from "react"
import {createRoot} from "react-dom/client"
import PremiumPopover from "../components/premium_popover"

class PopoverController extends Controller {
  static targets = ["link"]
  current_popover = null
  current_target = null

  show(event) {
    const target = event.currentTarget

    if (this.current_target === target) {
      this.hide()
      return
    }

    if (this.current_popover) {
      this.hide()
    }

    const container = document.createElement("div")
    document.body.appendChild(container)
    const root = createRoot(container)
    const popoverProps = {
      target: target,
      element: event.params.element,
      placement: "right",
      modifiers: [{
        name: "flip",
        options: {fallbackPlacements: ["right", "bottom", "top"]}
      }],
      on_close: () => {
        root.unmount()
        container.remove()
        this.resetState()
      },
      is_open: true
    }

    root.render(<PremiumPopover {...popoverProps} />)
    this.current_popover = {root, container}
    this.current_target = target
  }

  hide() {
    if (this.current_popover) {
      this.current_popover.root.unmount()
      this.current_popover.container.remove()
      this.resetState()
    }
  }

  resetState() {
    this.current_popover = null
    this.current_target = null
  }
}

export default PopoverController
